import React, { useEffect, useState} from 'react'
import { GetRequest,PostRequest, bookAgain, getDateFormatIPhone } from '../common/helper'
import { renderSvg } from './renderSvg'
import ViewBooking from './ViewBooking'
import { updateLoader } from "../../actions/search-actions"
import store from '../../store'
import AccountLoader from './accountLoader'
import CancelDetails from '../cancel/cancelDetails'
import Edit from '../edit/edit'
import RefundDtls from '../cancel/refundDtls';
import { apiUrl } from '../common/constants';
import Alert from '../common/alert';
import AlertNew from '../common/alertNew';
import moment from 'moment'

import { t, BOOKED_ON, BOOKING_DATE, BOOK_AGAIN, BUS_TYPE, CANCELLED, CANCEL_BOOKING, CLOSE_BOOKING, CLOSE_CANCEL_BOOKING, CLOSE_MODIFY_BOOKING, COMPLETED, JOURNEY_DATE, MODIFY_BOOKING, PNR, REFUND_DETAILS, SORT, TRIP_CODE, UPCOMING, VIEW_BOOKING,FAVOURITE, VIEW_ON_MAP, WL_TRANS } from '../../translations/ManageAccount/CardList'

const CardList = () => {
    // const dispatch=-useDispatch()
    const [tabs, setTabs] = useState(0)
    const [upcomingcardData, setUpcomingCardData] = useState([])
    const [upcomingfilteredData, setUpcomingFilteredData] = useState([])

    const [sortShow, setSortShow] = useState(false)
    const [selSortData, setSelSortData] = useState("");
    const [loader, setLoader] = useState(false);
    const [cancelled, setCancelled] = useState([]);
    const [completed, setCompleted] = useState([]);
    const [favourite, setFavourite] = useState([]);
    const [mobile, setMobile] = useState("");
    const [successmsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [favTripData, setFavTripData] = useState({});
    const [tcwlBooking, setTcwlBooking] = useState({});

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        let mobileNo = window.customerProfile.MobileNumber;
        setMobile(mobileNo);
        const url = `${window.url}/api/resource/APIMicrositeBookingDetails?MobileNo=${mobileNo}`;
        try {
            setLoader(true);
            const response = await fetch(url);
            store.dispatch(updateLoader(false));
            try {
                const data = await response.json();
                if (data.APIMicrositeBookingDetailsResult.BookingsList.length > 0) {
                    const updatedData = data.APIMicrositeBookingDetailsResult.BookingsList.map((val) => ({ ...val, viewBokking: false, showCancel: false, showEdit: false,Favourite:0})) || []
                    //console.log("updatedData", updatedData);
                    let up = [];
                    let can = [];
                    let comp = [];
                    
                    //trip code wise latest booking
                    let tcwlb = {};

                    updatedData.length > 0 && updatedData.map(booking => {
                        if (booking.IsUpComingTrip) {
                            up.push(booking);
                        } else {
                            if (booking.BookingStatus === "C") {
                                can.push(booking);
                            } else if (booking.BookingStatus === "B") {
                                comp.push(booking);

                                const currentMax = tcwlb[booking.TripCode];
                                const currentTime = new Date(booking.BookingDateTime);

                                if (!currentMax || currentTime > new Date(currentMax)) {
                                    tcwlb[booking.TripCode] = booking.BookingDateTime;
                                }
                            }
                        }
                    })

                    setUpcomingCardData(up);
                    setUpcomingFilteredData(up);
                    setCancelled(can);
                    setCompleted(comp);
                    setTcwlBooking(tcwlb);

                    setLoader(false);

                } else {
                    setLoader(false);
                    setUpcomingCardData([])
                }
            } catch (error) {
                setLoader(false)
                store.dispatch(updateLoader(false));
                return false;
            }
        }
        catch (err) {
            setLoader(false)
            store.dispatch(updateLoader(false));
            return err;
        }
    }

    useEffect(() => {
        if((tabs==1 || tabs==3) && completed && completed.length > 0 && Object.keys(favTripData).length === 0){
            getFavouriteTripData(); 
        }
    },[completed,tabs])

    const getFavouriteTripData = () => {
        
        const url = '/api/resource/getFavouriteTripData';

        GetRequest(url)
        .then((res) => {

            setLoader(false);

            if (res?.data && res?.data?.length > 0) {
                const favTripData = {};
                res.data.map(d => {
                        favTripData[d.trip_code] = parseInt(d.is_favourite);
                    }
                );
                setFavTripData(favTripData);
            } 
        })
        .catch((err) => {
            console.log(err);
            setLoader(false);
            setFavTripData({});
        });
    }

    useEffect(() => {

        const data = [];
        const ftData = [];

        for (let i = 0; i < completed.length; i++) {
            const item = { ...completed[i] };

            //after got favourite trip data, here we are updating completed booking Favourite value
            //for which trip code matched and also create favourite trip data
            if (item.TripCode && item.TripCode in favTripData) {

                item.Favourite = favTripData[item.TripCode];
                item.viewBokking = false;
                item.showCancel = false;
                item.showEdit = false;

                const bookingTime = new Date(item.BookingDateTime);
                const maxBookingTime = new Date(tcwlBooking[item.TripCode]);

                if (item.Favourite === 1 &&  bookingTime.getTime() === maxBookingTime.getTime()) {
                    ftData.push({ ...item });
                }
            }

            data.push(item);
        }

        setCompleted(data);
        setFavourite(ftData);

    }, [favTripData]);
    
    const viewBooking = (i, value,) => {
        const data = [...upcomingcardData];
        for(let i =0; i < data.length ; i++){
           data[i].viewBokking = false; 
        }
        data[i].viewBokking = value
        setUpcomingCardData(data)
    }

    const viewCancel = (i, value) => {
       const data = [...upcomingcardData];
        for(let i =0; i < data.length ; i++){
           data[i].showCancel = false; 
        }
        data[i].showCancel = value
        setUpcomingCardData(data)
    }

    const completedViewBooking = (i, value,) => {
        const data = [...completed];
        for(let i =0; i < data.length ; i++){
           data[i].viewBokking = false; 
        }
        data[i].viewBokking = value;
        setCompleted(data);
    }

    const handelToggleFavouriteTrip = (tripCode,favourite) => {

        if(tripCode){

            setLoader(true);

            const data = {tripCode,favourite:favourite?0:1};
            
            PostRequest(apiUrl.markFavourite, data).then((mfRes) => {

                if (mfRes.Success) {
                    setLoader(false);
                    //setSuccessMsg(mfRes.message);
                } else {
                    setErrorMsg(mfRes.errorMsg);
                    setLoader(false);
                }

                getFavouriteTripData();

            })
            .catch((err) => { 
                setLoader(false); 
            });
        }
    }

    const completedViewCancel = (i, value) => {
        const data = [...completed]
        for(let i =0; i < data.length ; i++){
           data[i].showCancel = false; 
        }
        data[i].showCancel = value;
        setCompleted(data)
    }

    const cancelledViewBooking = (i, value,) => {
        const data = [...cancelled]
        for(let i =0; i < data.length ; i++){
           data[i].viewBokking = false; 
        }
        data[i].viewBokking = value
        setCancelled(data);
    }

    const viewEdit = (i, value) => {
        const data = [...upcomingcardData]
        for(let i =0; i < data.length ; i++){
           data[i].showEdit = false; 
        }
        data[i].showEdit = value;
        setUpcomingCardData(data)
    }

    const hideEditDetails = (i, value) => {
        const data = [...upcomingcardData]
        for(let i =0; i < data.length ; i++){
           data[i].showEdit = false; 
        }
        data[i].showEdit = value
        setUpcomingCardData(data)
    }


    const sort = (data, type) => {
        if (type == 'JD') {
            const sortedData = data.sort((a, b) => {
                const dateA = new Date(a.DepartureTime);
                const dateB = new Date(b.DepartureTime);
                // Compare dates
                return dateA - dateB;
            });
            return sortedData;
        }

        if (type == 'BD') {
            const sortedData = data.sort((a, b) => {
                const dateA = new Date(a.BookingDateTime);
                const dateB = new Date(b.BookingDateTime);
                // Compare dates
                return dateA - dateB;
            });
            return sortedData;
        }
    }

    const handleJourney = () => {
        setSelSortData("JD")
        const sortedData = sort(upcomingcardData, 'JD');
        setUpcomingFilteredData(sortedData)
        setSortShow(false)

        // const data CardList.filter((val))
    }

    const handleBookingDate = () => {
        setSelSortData("BD")
        const sortedData = sort(upcomingcardData, 'BD');
        setUpcomingFilteredData(sortedData)
        setSortShow(false)
    }

    const handleCompletedJourney = () => {
        setSelSortData("JD")
        const sortedData = sort(completed, 'JD');
        setCompleted(sortedData)
        setSortShow(false)

        // const data CardList.filter((val))
    }
    const handleCompletedBookingDate = () => {
        setSelSortData("BD")
        const sortedData = sort(completed, 'BD');
        setCompleted(sortedData)
        setSortShow(false)
    }


    const handleCancelledJourney = () => {
        setSelSortData("JD")
        const sortedData = sort(cancelled, 'JD');
        setCompleted(sortedData)
        setSortShow(false)

        // const data CardList.filter((val))
    }
    const handleCancelledBookingDate = () => {
        setSelSortData("BD")
        const sortedData = sort(cancelled, 'BD');
        setCompleted(sortedData)
        setSortShow(false)
    }

    const handleFavouriteJourney = () => {
        setSelSortData("JD")
        const sortedData = sort(favourite, 'JD');
        setFavourite(sortedData)
        setSortShow(false)
    }

    const handleFavouriteBookingDate = () => {
        setSelSortData("BD")
        const sortedData = sort(favourite, 'BD');
        setFavourite(sortedData)
        setSortShow(false)
    } 

    const favouriteViewBooking = (i, value,) => {
        const data = [...favourite];
        for(let i =0; i < data.length ; i++){
           data[i].viewBokking = false; 
        }
        data[i].viewBokking = value;
        setFavourite(data);
    }

    const favouriteViewCancel = (i, value) => {
        const data = [...favourite]
        for(let i =0; i < data.length ; i++){
           data[i].showCancel = false; 
        }
        data[i].showCancel = value;
        setFavourite(data)
    }

    const showRefundData = (i, PNR) => {
        const data = [...cancelled]

        if (data[i].PNR === PNR) {
            data[i].showRefund = true
        } else {
            data[i].showRefund = false
        }

        setCancelled(data);
    }

    // console.log("upcoming", upcomingfilteredData);
    // console.log("cancelled", cancelled);
    // console.log("completed", completed);
    // console.log("favourite",favourite);
    // console.log("favTripData",favTripData);

    return (
        <div className="cards-container" >
            <div className="cardTabs-wrapper">
                <div className={`cardTab ${tabs == 0 && "active"}`} onClick={() => setTabs(0)}>{t(UPCOMING)}</div>
                <div className={`cardTab ${tabs == 1 && "active"}`} onClick={() => setTabs(1)}>{t(COMPLETED)}</div>
                <div className={`cardTab ${tabs == 2 && "active"}`} onClick={() => setTabs(2)}>{t(CANCELLED)}</div>
                <div className={`cardTab ${tabs == 3 && "active"}`} onClick={() => setTabs(3)}>{t(FAVOURITE)}</div>
                {/* <div className={`cardTab ${tabs == 3 && "active"}`} onClick={() => setTabs(3)}>{t(WL_TRANS)}</div> */}
            </div>
            {loader && <AccountLoader />}
            {tabs == 0 &&
                <React.Fragment>
                    <div className="sort">
                        <span>{t(SORT)}
                        </span>
                        <span onClick={() => setSortShow(!sortShow)}>{renderSvg("upDown")}</span>
                        {
                            sortShow &&
                            <div className="sorting-dropdown">
                                <div className={`item ${selSortData == "JD" && "active"}`} onClick={() => handleJourney()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(JOURNEY_DATE)}</span>
                                </div>
                                <div className={`item ${selSortData == "BD" && "active"}`} onClick={() => handleBookingDate()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(BOOKING_DATE)}</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="cards-wrapper scrollBlue" key="cards-wrapper-up">
                        {
                            upcomingfilteredData.length > 0 ?
                                <React.Fragment>
                                    {
                                        upcomingfilteredData.map((val, i) => {
                                            return (
                                                <React.Fragment key={`RFUp-${i}`}>
                                                    <div className="card" key={i}>
                                                        <div className="cardHeader" >
                                                            <p>{t(PNR)} {val.BookingRefNo || val.PNR} | {t(TRIP_CODE)} {val.TripCode} | {t(BUS_TYPE)} {val.ServiceType} | {t(BOOKED_ON)} {getDateFormatIPhone(val.BookingDateTime, "DD MMM YY, HH:mm")}</p>
                                                            {
                                                                val.viewBokking ?
                                                                    <button onClick={() => viewBooking(i, false)}>{t(CLOSE_BOOKING)}</button> :
                                                                    <button onClick={() => { viewBooking(i, true); viewEdit(i, false); viewCancel(i, false) }}>{t(VIEW_BOOKING)}</button>
                                                            }
                                                        </div>
                                                        <div className="cardContent">
                                                            <ul className="cardLeft">
                                                                <li>
                                                                    <span className='circle'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.FromCityName} on {getDateFormatIPhone(val.DepartureTime, "DD MMM YY, HH:mm")} </h4>
                                                                        <p>{val.PickupName} </p>
                                                                        {/* <a>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className='square'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.ToCityName} on {getDateFormatIPhone(val.ArrivalTime, "DD MMM YY, HH:mm")}  </h4>
                                                                        <p>{val.DroppoffName} </p>
                                                                        {/* <a>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <div className="cardRight">
                                                                {
                                                                    val.showEdit ?
                                                                        <button className={val.showEdit ? 'active' : ''} onClick={() => viewEdit(i, false)}>{t(CLOSE_MODIFY_BOOKING)}</button>
                                                                        :
                                                                        <button onClick={() => { viewEdit(i, true); viewBooking(i, false); viewCancel(i, false) }}>{t(MODIFY_BOOKING)}</button>
                                                                }

                                                                {
                                                                    val.showCancel ?
                                                                        <button className={val.showCancel ? 'active' : ''} onClick={() => viewCancel(i, false)}>{t(CLOSE_CANCEL_BOOKING)}</button>
                                                                        :
                                                                        <button onClick={() => { viewCancel(i, true); viewEdit(i, false); viewBooking(i, false); }}>{t(CANCEL_BOOKING)}</button>
                                                                }
                                                                <button onClick={() => bookAgain(val)}>{t(BOOK_AGAIN)}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        val.viewBokking &&
                                                        <div className="viewBooking-wrapper">
                                                            <ViewBooking pnr={val.PNR} type="" mobile={mobile} />
                                                        </div>
                                                    }

                                                    {
                                                        val.showCancel && <CancelDetails pnr={val.BookingRefNo} mobile={mobile} />
                                                    }

                                                    {
                                                        val.showEdit && <Edit
                                                            routeID={val.RouteCode || "72~58~1661~894~2024-04-04"}
                                                            BookingRefNo={val.BookingRefNo}
                                                            PNR={val.PNR}
                                                            defPickup={{ id: val.PickupID, name: val.PickupName }}
                                                            defDropOff={{ id: val.DropoffID, name: val.DroppoffName }}
                                                            cancel={() => hideEditDetails(i, false)}
                                                            mobile={mobile}
                                                        />
                                                    }
                                                </React.Fragment>

                                            )
                                        })
                                    }
                                </React.Fragment> :
                                <React.Fragment></React.Fragment>
                        }
                    </div>
                </React.Fragment>
            }

            {/*for completed tab */}
            {tabs == 1 &&
                <React.Fragment>
                    <div className="sort">
                        <span>{t(SORT)}
                        </span>
                        <span onClick={() => setSortShow(!sortShow)}>{renderSvg("upDown")}</span>
                        {
                            sortShow &&
                            <div className="sorting-dropdown">
                                <div className={`item ${selSortData == "JD" && "active"}`} onClick={() => handleCompletedJourney()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(JOURNEY_DATE)}</span>
                                </div>
                                <div className={`item ${selSortData == "BD" && "active"}`} onClick={() => handleCompletedBookingDate()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(BOOKING_DATE)}</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="cards-wrapper scrollBlue" key="cards-wrapper-comp">
                        {
                            completed.length > 0 ?
                                <React.Fragment>
                                    {
                                        completed.map((val, i) => {
                                            return (
                                                <React.Fragment key={`RFComp-${i}`}>
                                                    <div className="card" key={i}>
                                                        <div className="cardHeader" >
                                                            <p>{t(PNR)} {val.BookingRefNo || val.PNR} | {t(TRIP_CODE)} {val.TripCode} | {t(BUS_TYPE)} {val.ServiceType} | {t(BOOKED_ON)} {getDateFormatIPhone(val.BookingDateTime, "DD MMM YY, HH:mm")}</p>
                                                            <div className="chRight">
                                                                <div className={`favouriteWrap tooltip ${i==0 ? 'first':''}`}  onClick={() => handelToggleFavouriteTrip(val.TripCode,val.Favourite)}>
                                                                    {val.Favourite ? renderSvg("favouriteRed") : renderSvg("favouriteGray")}
                                                                    <span className="tooltiptext">{val.Favourite ? 'Added as Favourite Trip' : 'Add as Favourite Trip'}</span>
                                                                </div>
                                                                {
                                                                    val.viewBokking ?
                                                                        <button onClick={() => completedViewBooking(i, false)}>{t(CLOSE_BOOKING)}</button> :
                                                                        <button onClick={() => completedViewBooking(i, true)}>{t(VIEW_BOOKING)}</button>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="cardContent">
                                                            <ul className="cardLeft">
                                                                <li>
                                                                    <span className='circle'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.FromCityName} on {getDateFormatIPhone(val.DepartureTime, "DD MMM YY, HH:mm")} </h4>
                                                                        <p>{val.PickupName} </p>
                                                                        {/* <a href=''>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className='square'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.ToCityName} on {getDateFormatIPhone(val.ArrivalTime, "DD MMM YY, HH:mm")}  </h4>
                                                                        <p>{val.DroppoffName} </p>
                                                                        {/* <a href=''>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <div className="cardRight">
                                                                {/* <button>Edit Booking</button>
                                                                <button>Prepone/Postpone</button>
                                                                <button>{t(CANCEL_BOOKING)}</button> */}
                                                                {
                                                                    val.BookingStatus == 'B' && val.IsServiceCancel == 1 && (
                                                                        val.showCancel ?
                                                                            <button className={val.showCancel ? 'active' : ''} onClick={() => completedViewCancel(i, false)}>{t(CLOSE_CANCEL_BOOKING)}</button>
                                                                            :
                                                                            <button onClick={() => { completedViewCancel(i, true);}}>{t(CANCEL_BOOKING)}</button>
                                                                    ) 
                                                                }
                                                                <button onClick={() => bookAgain(val)}>{t(BOOK_AGAIN)}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        val.viewBokking &&
                                                        <div className="viewBooking-wrapper">
                                                            <ViewBooking pnr={val.PNR} type={"completed"} mobile={mobile} />
                                                        </div>
                                                    }

                                                    {
                                                        val.showCancel && <CancelDetails pnr={val.BookingRefNo} mobile={mobile} />
                                                    }

                                                </React.Fragment>

                                            )
                                        })
                                    }
                                </React.Fragment> :
                                <React.Fragment></React.Fragment>
                        }
                    </div>
                </React.Fragment>
            }

            {tabs == 2 &&
                <React.Fragment>
                    <div className="sort">
                        <span>{t(SORT)}
                        </span>
                        <span onClick={() => setSortShow(!sortShow)}>{renderSvg("upDown")}</span>
                        {
                            sortShow &&
                            <div className="sorting-dropdown">
                                <div className={`item ${selSortData == "JD" && "active"}`} onClick={() => handleCancelledJourney()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(JOURNEY_DATE)}</span>
                                </div>
                                <div className={`item ${selSortData == "BD" && "active"}`} onClick={() => handleCancelledBookingDate()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(BOOKING_DATE)}</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="cards-wrapper scrollBlue" key="cards-wrapper-can">
                        {
                            cancelled.length > 0 ?
                                <React.Fragment>
                                    {
                                        cancelled.map((val, i) => {
                                            return (
                                                <React.Fragment key={`RFCan-${i}`}>
                                                    <div className="card" key={i}>
                                                        <div className="cardHeader" >
                                                            <p>{t(PNR)} {val.BookingRefNo || val.PNR} | {t(TRIP_CODE)} {val.TripCode} | {t(BUS_TYPE)} {val.ServiceType} | {t(BOOKED_ON)} {getDateFormatIPhone(val.BookingDateTime, "DD MMM YY, HH:mm")}</p>
                                                            {
                                                                val.viewBokking ?
                                                                    <button onClick={() => cancelledViewBooking(i, false)}>{t(CLOSE_BOOKING)}</button> :
                                                                    <button onClick={() => cancelledViewBooking(i, true)}>{t(VIEW_BOOKING)}</button>
                                                            }
                                                        </div>
                                                        <div className="cardContent">
                                                            <ul className="cardLeft">
                                                                <li>
                                                                    <span className='circle'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.FromCityName} on {getDateFormatIPhone(val.DepartureTime, "DD MMM YY, HH:mm")} </h4>
                                                                        <p>{val.PickupName} </p>
                                                                        {/* <a href=''>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className='square'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.ToCityName} on {getDateFormatIPhone(val.ArrivalTime, "DD MMM YY, HH:mm")}  </h4>
                                                                        <p>{val.DroppoffName} </p>
                                                                        {/* <a href=''>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <div className="cardRight">
                                                                {/* <button>Edit Booking</button>
                                                                <button>Prepone/Postpone</button>
                                                                <button>{t(CANCEL_BOOKING)}</button>
                                                                <button>{t(BOOK_AGAIN)}</button> */}
                                                                <button onClick={() => showRefundData(i, val.PNR)}
                                                                    className={val.showRefund ? `disable` : ''}
                                                                >{t(REFUND_DETAILS)}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        val.viewBokking &&
                                                        <div className="viewBooking-wrapper">
                                                            <ViewBooking pnr={val.PNR} type={"cancelled"} mobile={mobile} />
                                                        </div>
                                                    }
                                                    {
                                                        val.showRefund && <RefundDtls pnr={val.PNR} type={"cancelled"} mobile={mobile} />
                                                    }
                                                </React.Fragment>

                                            )
                                        })
                                    }
                                </React.Fragment> :
                                <React.Fragment></React.Fragment>
                        }
                    </div>
                </React.Fragment>
            }
            {/*for favourite trip tab */}
            {tabs == 3 &&
                <React.Fragment>
                    <div className="sort">
                        <span>{t(SORT)}
                        </span>
                        <span onClick={() => setSortShow(!sortShow)}>{renderSvg("upDown")}</span>
                        {
                            sortShow &&
                            <div className="sorting-dropdown">
                                <div className={`item ${selSortData == "JD" && "active"}`} onClick={() => handleFavouriteJourney()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(JOURNEY_DATE)}</span>
                                </div>
                                <div className={`item ${selSortData == "BD" && "active"}`} onClick={() => handleFavouriteBookingDate()}>
                                    <span className='circlepoint'></span>
                                    <span>{t(BOOKING_DATE)}</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="cards-wrapper scrollBlue" key="cards-wrapper-fav">
                        {
                            favourite.length > 0 ?
                                <React.Fragment>
                                    {
                                        favourite.map((val, i) => {
                                            return (
                                                <React.Fragment key={`RFF-${i}`}>
                                                    <div className="card" key={i}>
                                                        <div className="cardHeader" >
                                                            <p>{t(PNR)} {val.BookingRefNo || val.PNR} | {t(TRIP_CODE)} {val.TripCode} | {t(BUS_TYPE)} {val.ServiceType} | {t(BOOKED_ON)} {getDateFormatIPhone(val.BookingDateTime, "DD MMM YY, HH:mm")}</p>
                                                            <div className="chRight">
                                                                <div className={`favouriteWrap tooltip ${i==0 ? 'first':''}`}  onClick={() => handelToggleFavouriteTrip(val.TripCode,val.Favourite)}>
                                                                    {val.Favourite ? renderSvg("favouriteRed") : renderSvg("favouriteGray")}
                                                                    <span className="tooltiptext">{val.Favourite ? 'Added as Favourite Trip' : 'Add as Favourite Trip'}</span>
                                                                </div>
                                                                {
                                                                    val.viewBokking ?
                                                                        <button onClick={() => favouriteViewBooking(i, false)}>{t(CLOSE_BOOKING)}</button> :
                                                                        <button onClick={() => favouriteViewBooking(i, true)}>{t(VIEW_BOOKING)}</button>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="cardContent">
                                                            <ul className="cardLeft">
                                                                <li>
                                                                    <span className='circle'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.FromCityName} on {getDateFormatIPhone(val.DepartureTime, "DD MMM YY, HH:mm")} </h4>
                                                                        <p>{val.PickupName} </p>
                                                                        {/* <a href=''>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <span className='square'></span>
                                                                    <div className="leftTop-content">
                                                                        <h4>{val.ToCityName} on {getDateFormatIPhone(val.ArrivalTime, "DD MMM YY, HH:mm")}  </h4>
                                                                        <p>{val.DroppoffName} </p>
                                                                        {/* <a href=''>{renderSvg("viewMap")} <u>{t(VIEW_ON_MAP)}</u></a> */}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <div className="cardRight">
                                                                {/* <button>Edit Booking</button>
                                                                <button>Prepone/Postpone</button>
                                                                <button>{t(CANCEL_BOOKING)}</button> */}
                                                                {
                                                                    val.BookingStatus == 'B' && val.IsServiceCancel == 1 && (
                                                                        val.showCancel ?
                                                                            <button className={val.showCancel ? 'active' : ''} onClick={() => favouriteViewCancel(i, false)}>{t(CLOSE_CANCEL_BOOKING)}</button>
                                                                            :
                                                                            <button onClick={() => { favouriteViewCancel(i, true);}}>{t(CANCEL_BOOKING)}</button>
                                                                    ) 
                                                                }
                                                                <button onClick={() => bookAgain(val)}>{t(BOOK_AGAIN)}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        val.viewBokking &&
                                                        <div className="viewBooking-wrapper">
                                                            <ViewBooking pnr={val.PNR} type={"completed"} mobile={mobile} />
                                                        </div>
                                                    }

                                                    {
                                                        val.showCancel && <CancelDetails pnr={val.BookingRefNo} mobile={mobile} />
                                                    }

                                                </React.Fragment>

                                            )
                                        })
                                    }
                                </React.Fragment> :
                                <React.Fragment></React.Fragment>
                        }
                    </div>
                </React.Fragment>
            }

            {errorMsg && (
                <Alert
                    msg={errorMsg}
                    error={true}
                    close={() => setErrorMsg("")}
                />
            )}

            {successmsg && (
                <AlertNew
                    msg={successmsg}
                    buttonText=""
                    success={true}
                    close={() => {
                    setSuccessMsg("");
                    //window.location.reload();
                    //setTabs(4)
                    // window.location.href = "/account";
                    }}
                />
            )}
        </div>
    )
}

export default CardList